// extracted by mini-css-extract-plugin
export default {"account":"Account_account__2Hiji","controls":"Account_controls__ILaAZ","error":"Account_error__KIUiD","button-80":"Account_button-80__UhMR1","flex":"Account_flex__jAZFP"};